import React, { Component } from 'react'
import style from './style.css'


export default class Avatar extends Component {
    render() {
        let props = this.props

        let styleInline = {
            ...props.style,
            width: `${props.size}px` || props.width || '',
            height: `${props.size}px` || props.height || '',
            border: `${props.border}` || '',
        }

        if(props.img) {
            styleInline['backgroundImage'] = `url('${props.img}')`
        }

        let image = () => (
            <div className={[props.secondary ? style.secondary : null].join(' ')}>
                <div
                    className={[style.avatar, this.props.imgType === 'group' ? style.group : null].join(' ')}
                    style={styleInline}
                />
            </div>
        )
        
        return (
            <div className={`${[this.props.className, style.avatarBox].join(' ')}`}>
                { (this.props.href && this.props.href) ? (
                    <a className={style.link} href={this.props.href}>
                        {image()}
                    </a>
                ) : image()}
                
                {props.children}
            </div>
        )
    } 
}

export const Bullet = ({ size, children, success, width, height }) => (
    <span
        className={[style.bullet, success ? style.success : null].join(' ')}
        style={{
                ...style,
                width: `${size}px` || width || null,
                height: `${size}px` || height || null,
            }}
        >
        {children}
    </span>
)


// WEBPACK FOOTER //
// ./src/SPRINTA/atoms/Avatar/index.js